import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetAssignerUserExpenseData from "../AssignerUser/Expense/GetAssignerUserExpenseDataInFirebase";

const GetExpenseDataFirebase = async (state, dispatch, sharedBusinesses = null) => {
  if (!state?.USERID || state?.USERID == null || state?.USERID == undefined)
    return null;

  try {
    const userRef = ref(
      database,
      `invoiceGenerator/users/${state?.USERID}/expense`
    );
    const snapshot = await get(userRef);
    let data = snapshot.val();

    let formattedData = [];

    if (data) {
      // 🔥 Filter out deleted expenses
      const activeExpenses = Object.entries(data).filter(
        ([, expense]) => !expense?.isDeleted
      );

      formattedData = activeExpenses.map(([uniqueID, info]) => ({
        uniqueID, // Firebase unique ID
        ...info,  // Spread existing expense data
        isShared: false
      }));
    }

    /* -------- FETCH SHARED EXPENSES -------- */
    const businessesToUse = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];
    if (businessesToUse.length) {
      const sharedExpenses = await GetAssignerUserExpenseData(state, dispatch, businessesToUse);
      formattedData = [
        ...formattedData,
        ...sharedExpenses
      ];
    }

    /* -------- SORT AND NUMBER GLOBALLY -------- */
    let sortedExpenseData = formattedData
      .sort(
        (a, b) => new Date(parseInt(b.date)) - new Date(parseInt(a.date))
      )
      .map((item, index) => ({
        srNo: index + 1, // Assign serial number after sorting
        ...item,
      }));

    dispatch({ type: actionType.EXPENSE, payload: sortedExpenseData });

    return sortedExpenseData;
  } catch (error) {
    console.error("Error fetching expense data:", error);
    return null;
  }
};

export default GetExpenseDataFirebase;
